<template>
  <div class="chartbox">
    <div ref="right" class="right">
      <div ref="rightContent" class="rightContent">
        <div class="contentBox">
          <div ref="kline_boxwp" class="periodWrap kline_boxwp">
            <div class="btnGroup">
              <div v-for="(item,index) in KLinePeriodMenu" :key="item.ID" class="chartbtn" :class="{active: KLinePeriodIndex == index}" @click="OnClickKLinePeriodMenu(index,item)">{{ item.Name }}</div>
            </div>
          </div>
          <div id="hqchart_kline" ref="kline2" class="hqchart"></div>
          <div v-show="isShowTooltipSelf" id="customtooltip" ref="customtooltip" class="customtooltip">
            <div v-for="(item, i) in tooltipData" :key="i" class="customtooltiprow">
              <div class="customtooltipleft" :style="`color:${item.titleColor}`">{{ item.ch }}</div>
              <div class="customtooltipright" :style="`color:${item.color}`">{{ item.vol }}</div>
              <div v-if="item.svol" class="customtooltipright" :style="`color:${item.color}`">{{ item.svol }}</div>
            </div>
            <!-- <button @click="EnableShowTooltip(false)">关闭</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- 防止 hqchart影响其他页面 -->
<style src="hqchart/src/jscommon/umychart.resource/css/tools.css" scoped>
</style>
<!-- 防止 hqchart影响其他页面 -->
<style src="hqchart/src/jscommon/umychart.resource/font/iconfont.css" scoped>
</style>
<script>
/* eslint-disable no-dupe-keys */
/* eslint-disable brace-style */
import _ from 'lodash'
import HQChart from 'hqchart'
import HDF from './hqchartjs/HQData.js'

// 源码调试用
// import Chart from '../jscommon/umychart.vue/umychart.vue.js'
// import '../jscommon/umychart.resource/css/tools.css'
// import '../jscommon/umychart.resource/font/iconfont.css'
// var HQChart={ Chart:Chart };
HQChart.Chart.MARKET_SUFFIX_NAME.GetMarketStatus = function(symbol) { return 2 } // 一直交易

function DefaultData() { }

DefaultData.GetMinuteOption = function(Symbol) {
  var option =
    {
      Type: '分钟走势图', // 创建图形类型
      // Type:'分钟走势图横屏',

      Windows: // 窗口指标
        [
          { Index: 'MACD', Modify: false, Change: false, Close: false }
        ],

      Symbol: Symbol,
      IsAutoUpdate: true, // 是自动更新数据
      AutoUpdateFrequency: 20000,
      DayCount: 1, // 1 最新交易日数据 >1 多日走势图
      IsShowRightMenu: false, // 是否显示右键菜单
      // CorssCursorTouchEnd:true,

      CorssCursorInfo: { Left: 1, Right: 1 },

      MinuteLine:
        {
          IsDrawAreaPrice: true, // 是否画价格面积图
          IsShowAveragePrice: true // 不显示均线
        },

      Border: // 边框
        {
          Left: 40, // 左边间距
          Right: 40, // 右边间距
          Top: 25,
          Bottom: 25,
          AutoRight: { Blank: 10, MinWidth: 40 },
          AutoLeft: { Blank: 10, MinWidth: 40 }
        },

      Frame: // 子框架设置
        [
          { SplitCount: 5 },
          { SplitCount: 3 }
        ],

      ExtendChart: // 扩展图形
        [
          // {Name:'MinuteTooltip' }  //手机端tooltip
        ]
    }

  return option
}

DefaultData.GetMinuteIndexMenu = function() {
  var data =
    [
      { Name: 'MACD', ID: 'MACD', WindowIndex: 2 },
      { Name: 'KDJ', ID: 'KDJ', WindowIndex: 2 },
      { Name: 'DMI', ID: 'DMI', WindowIndex: 2 },
      { Name: 'ROC', ID: 'ROC', WindowIndex: 2 }
    ]

  return data
}

DefaultData.GetKLineIndexMenu = function() {
  var data =
    [
      { Name: 'MA', ID: 'MA', WindowIndex: 0 },
      { Name: 'BOLL', ID: 'BOLL', WindowIndex: 0 },
      { Name: 'MACD', ID: 'MACD', WindowIndex: 1 },
      { Name: 'KDJ', ID: 'KDJ', WindowIndex: 1 },
      { Name: 'DMI', ID: 'DMI', WindowIndex: 1 },
      { Name: 'ROC', ID: 'ROC', WindowIndex: 1 }
    ]

  return data
}

DefaultData.GetTestSymbolMenu = function() {
  // 品种代码规则 ${东方财富品种代码}_${东方财富市场}.${HQChart内部市场后缀}
  var data =
    [
      {
        Title: '订单',
        Icon: '',
        Sub:
            [
              {
                Name: '测试商品',
                Code: '243_32.sh'
              }
            ]
      }
    ]

  return data
}

DefaultData.GetKLineOption = function(islong, Symbol, time) {
  var option =
    {
      Type: '历史K线图', // 创建图形类型
      DragDownload: { Minute: { Enable: true }}, // 拖拽下载
      Windows: // 窗口指标
        islong
          ? [
            { Index: 'MA', Modify: true, Change: false },
            { Index: 'VOL', Modify: true, Change: true, Close: true },
            { Index: 'MACD', Modify: true, Change: true, Close: true }
          ] : [
            { Index: 'MA', Modify: true, Change: false },
            { Index: 'VOL', Modify: true, Change: true, Close: true }
          ],

      Symbol: Symbol,
      IsAutoUpdate: true, // 是自动更新数据
      AutoUpdateFrequency: window.g.TV_REFRESH_TIME ? window.g.TV_REFRESH_TIME : 10000,
      IsApiPeriod: true,
      IsShowRightMenu: false, // 是否显示右键菜单
      // CorssCursorTouchEnd:true,
      IsCorssOnlyDrawKLine: true, // 十字光标只能在k线上

      KLine:
        {
          DragMode: 1, // 拖拽模式 0 禁止拖拽 1 数据拖拽 2 区间选择
          Right: 0, // 复权 0 不复权 1 前复权 2 后复权
          Period: time, // 周期 0 日线 1 周线 2 月线 3 年线
          MaxReqeustDataCount: 1000, // 数据个数
          // PageSize: 100, // 一屏显示多少数据
          DataWidth: 8, // 初始一屏显示的K线宽度。K线个数有K线宽度内部计算得到。 注意： PageSize / DataWidth 只能设置一模式
          KLineDoubleClick: false, // 双击分钟走势图
          IsShowTooltip: false, // 是否显示K线提示信息
          DrawType: 3, // K线类型 0=实心K线柱子 1=收盘价线 2=美国线 3=空心K线柱子 4=收盘价面积图 5=订单流
          RightSpaceCount: 2
        },

      CorssCursorInfo: { Left: 0, Right: 1 },

      KLineTitle: // 标题设置
        {
          IsShowName: true, // 不显示股票名称
          IsShowSettingInfo: true // 不显示周期/复权
        },

      Border: // 边框
        {
          Left: 2, // 左边间距
          Right: 60, // 右边间距
          Top: 0, // 25
          Bottom: 25
          // AutoRight: { Blank: 10, MinWidth: 75 }
        },

      Frame: // 子框架设置
        [
          {
            SplitCount: 5, IsShowLeftText: false,
            Custom:
                [
                  // {
                  //   Type: 0,
                  //   Position: 'right'
                  // },
                  { 
                    Type:0,
                    Position:'right',LineType:1, 
                    PositionEx:1
                  },
                ]
          },
          { SplitCount: 3, IsShowLeftText: false },
          { SplitCount: 3, IsShowLeftText: false }
        ],

      ExtendChart: // 扩展图形
        [
          // { Name:'KLineTooltip' },  //手机端tooltip
        ]
    }

  return option
}

DefaultData.GetMinuteDayMenu = function() {
  var data =
    [
      { Name: '1日', ID: 1 },
      { Name: '2日', ID: 2 },
      { Name: '3日', ID: 3 },
      { Name: '4日', ID: 4 },
      { Name: '5日', ID: 5 }
    ]

  return data
}

DefaultData.GetKLinePeriodMenu = function() {
  // hqchart精度 0=日线 1=周线 2=月线 3=年线 4=1分钟 5=5分钟 6=15分钟 7=30分钟 8=60分钟
  const data =
    [
      { Name: '分时', ID: 'fs' },
      { Name: '1分', ID: 20001 },
      { Name: '3分', ID: 20003 },
      { Name: '5分', ID: 5 },
      { Name: '10分', ID: 20010 },
      { Name: '15分', ID: 6 },
      { Name: '30分', ID: 7 },
      { Name: '60分', ID: 8 },
      { Name: '2小时', ID: 20120 },
      { Name: '4小时', ID: 20240 },
      { Name: '日', ID: 0 },
      { Name: '周', ID: 1 },
      { Name: '月', ID: 2 }
    ]

  return data
}

DefaultData.GetKLineRightMenu = function() {
  var data =
    [
      { Name: '不复权', ID: 0 },
      { Name: '前复权', ID: 1 },
      { Name: '后复权', ID: 2 }
    ]

  return data
}
// 行情tooltip提示信息格式
/**
 * defaultfloatPrecision 价格精度
 * defaultnumPrecision 数量精度
 */
function CustomHistoryDataStringFormat(defaultfloatPrecision, defaultnumPrecision)
{
  this.Value // 数据
  this.Text // 输出字符串

  this.Symbol
  this.UpColor = 'rgb(238,21,21)' // 上涨颜色
  this.DownColor = 'rgb(25,158,0)' // 下跌颜色
  this.UnchagneColor = 'rgb(0,0,0)' // 平盘

  this.VolColor = 'rgb(43,54,69)' // 成交量
  this.AmountColor = 'rgb(43,54,69)' // 成交金额
  this.LanguageID = 0 // 语言  0 中文 1 英文
  this.LineCount = 0 // 一共几行
  this.Width = 157 // 宽度
  this.Height // 高度

  this.Operator = function() // 拼div html 字符串
  {
    var data = this.Value.Data
    if (!data) return false

    const WEEK_NAME = ['日', '一', '二', '三', '四', '五', '六']

    var date = new Date(parseInt(data.Date / 10000), (data.Date / 100 % 100 - 1), data.Date % 100)
    var strDate = `${String(data.Date).slice(0, 4)}-${String(data.Date).slice(4, 6)}-${String(data.Date).slice(6, 8)}`// 日期 可以根据需求自己格式化日期
    var title2 = `星期${WEEK_NAME[date.getDay()]}` // 星期
    if (data.Time >= 0) title2 = `${String(data.Time).length === 3 ? String(data.Time).slice(0, 1) : String(data.Time).slice(0, 2)}:${String(data.Time).slice(-2)}` // 时间 可以根据需求自己格式化日期

    var increase = null
    if (data.YClose > 0) increase = (data.Close - data.YClose) / data.YClose * 100
    var hl = data.YClose > 0 ? data.Close - data.YClose : null
    var strText =
                    "<span class='tooltip-title'>" + strDate + '&nbsp&nbsp' + title2 + '</span>' +
                    "<span class='tooltip-con'>开盘</span>" +
                    "<span class='tooltip-num' style='color:" + this.GetColor(data.Open, data.YClose) + ";'>" + data.Open.toFixed(defaultfloatPrecision) + '</span><br/>' +
                    "<span class='tooltip-con'>最高</span>" +
                    "<span class='tooltip-num' style='color:" + this.GetColor(data.High, data.YClose) + ";'>" + data.High.toFixed(defaultfloatPrecision) + '</span><br/>' +
                    "<span class='tooltip-con'>最低</span>" +
                    "<span class='tooltip-num' style='color:" + this.GetColor(data.Low, data.YClose) + ";'>" + data.Low.toFixed(defaultfloatPrecision) + '</span><br/>' +
                    "<span class='tooltip-con'>收盘</span>" +
                    "<span class='tooltip-num' style='color:" + this.GetColor(data.Close, data.YClose) + ";'>" + data.Close.toFixed(defaultfloatPrecision) + '</span><br/>' +
                    "<span class='tooltip-con'>均价</span>" +
                    "<span class='tooltip-num' style='color:" + this.VolColor + ";'>" + (data.Vol > 0 ? data.Amount / data.Vol * 100 : data.Open).toFixed(defaultfloatPrecision) + '</span><br/>' +
                    // "<span style='color:"+this.YClose+";font:微软雅黑;font-size:12px'>&nbsp;前收: "+HQChart.ChartIFrameSplitOperator.FormatValueString(data.YClose,2)+"</span><br/>"+
                    "<span class='tooltip-con'>涨跌</span>" +
                    (increase == null ? "<span class='tooltip-num' style='color:" + this.GetColor(0, 0) + ";'>" + '--' + '</span><br/>'
                      : "<span class='tooltip-num' style='color:" + this.GetColor(increase, 0) + ";'>" + hl.toFixed(defaultfloatPrecision) + '</span><br/>') +
                    "<span class='tooltip-con'>涨幅</span>" +
                    (increase == null ? "<span class='tooltip-num' style='color:" + this.GetColor(0, 0) + ";'>" + '--' + '</span><br/>'
                      : "<span class='tooltip-num' style='color:" + this.GetColor(increase, 0) + ";'>" + increase.toFixed(2) + '%' + '</span><br/>') +
                    "<span class='tooltip-con'>数量</span>" +
                    "<span class='tooltip-num' style='color:" + this.VolColor + ";'>" + HQChart.Chart.IFrameSplitOperator.FormatValueString(data.Vol / 100, defaultnumPrecision, this.LanguageID) + '</span><br/>' +
                    // "<span class='tooltip-con'>金额</span>" +
                    // "<span class='tooltip-num' style='color:" + this.AmountColor + ";'>" + HQChart.Chart.IFrameSplitOperator.FormatValueString(data.Amount, defaultfloatPrecision, this.LanguageID) + '</span><br/>' +
                    "<span class='tooltip-con'>存货</span>" +
                    "<span class='tooltip-num' style='color:" + this.VolColor + ";'>" + HQChart.Chart.IFrameSplitOperator.FormatValueString(data.Position, defaultnumPrecision, this.LanguageID) + '</span><br/>'

    this.LineCount = 10
    // if (data.FlowCapital > 0) // 股票换手率
    // {
    //   var value = data.Vol / data.FlowCapital * 100
    //   strText += "<span class='tooltip-con'>换手</span>" +
    //                 "<span class='tooltip-num' style='color:" + this.AmountColor + ";'>" + value.toFixed(2) + '%' + '</span><br/>'
    //   ++this.LineCount
    // }

    // 显示叠加股票名称
    // if (this.Value.ChartPaint.Name == 'Overlay-KLine')
    // {
    //   var title = "<span style='color:rgb(0,0,0);font:微软雅黑;font-size:12px;text-align:center;display: block;'>" + this.Value.ChartPaint.Title + '</span>'
    //   strText = title + strText
    //   ++this.LineCount
    // }

    // 增加一个字段
    // strText += "<span  class='tooltip-con' style='color:rgb(0,45,255);'>字段</span><span class='tooltip-num' style='color:rgb(0,255,255);'>888.8</span> <br/> "
    // ++this.LineCount

    this.Text = strText

    this.Width = 157
    this.Height = this.LineCount * 25 // 每行高度25
    return true
  }

  this.GetColor = function(price, yclse)
  {
    if (price > yclse) return this.UpColor
    else if (price < yclse) return this.DownColor
    else return this.UnchagneColor
  }
}

export default
{
  // eslint-disable-next-line no-undef
  /**
   * selfItem: 默认商品id
   * selectItem: 商品参数,无效
   * isLong: 是否为展开形式,展开加载macd
   * time: 当前页面选择的时间精度
   * buttonIndex: 选中按钮下标
   * coinDigitalNum: 价格精度位数 1,2,3
   * quantityNum: 数量精度位数 1,2,3
   */
  props: ['selfItem', 'selectItem', 'isLong', 'time', 'buttonIndex', 'coinDigitalNum', 'quantityNum'],
  data() {
    var data = {
      MinuteDayMenu: DefaultData.GetMinuteDayMenu(),
      MinuteDayIndex: 0,

      KLinePeriodMenu: DefaultData.GetKLinePeriodMenu(),
      KLinePeriodIndex: 0,

      KLineRightMenu: DefaultData.GetKLineRightMenu(),
      KLineRightIndex: 0,
      IsShowRightMenu: true,

      MinuteIndexMenu: DefaultData.GetMinuteIndexMenu(),
      KLineIndexMenu: DefaultData.GetKLineIndexMenu(),

      Symbol: `${this.selfItem?.symbolId}_32.sh`, // HQChart内部编码美股加后缀.usa AAPL.usa
      Chart: null, // 图形控件  分时图
      KLineChart: null, // 图形控件  K线图
      NavMenuAry: DefaultData.GetTestSymbolMenu(),

      VolChartHeight: 10,
      chartType: 'kline',

      isShowTooltipSelf: true,
      tooltipData: [
        {
          en: 'date',
          ch: '日期',
          vol: '',
          titleColor: '#fff',
          color: '#fff',
          svol: ''
        },
        // {
        //   en: 'time',
        //   // ch: '时间',
        //   ch: '',
        //   vol: '',
        //   titleColor: '#fff',
        //   color: '#fff'
        // },
        {
          en: 'Open',
          ch: '开盘',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'High',
          ch: '最高',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'Low',
          ch: '最低',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'Close',
          ch: '收盘',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'Ave',
          ch: '均价',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'hl',
          ch: '涨跌',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'increase',
          ch: '涨幅',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        {
          en: 'Vol',
          ch: '数量',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        },
        // {
        //   en: 'Amount',
        //   ch: '金额',
        //   vol: '',
        //   titleColor: '#fff',
        //   color: '#fff'
        // },
        {
          en: 'Position',
          ch: '存货',
          vol: '',
          titleColor: '#fff',
          color: '#fff'
        }
      ],
      initTimer: null
    }

    return data
  },
  watch: {
    selfItem(val, oldVal) {
      this.ChangeSymbol(`${val.symbolId}_32.sh`)
    },
    buttonIndex(val) {
      this.KLinePeriodIndex = JSON.parse(JSON.stringify(val))
    }
  },
  mounted() {
    this.OnSize()
    this.SetChartStyle()
    this.$nextTick(() => {
      // this.CreateMinuteChart();
      this.CreateKLineChart()
    })
    window.onresize = _.debounce(this.OnSize, 200)
    const that = this
    HQChart.Chart.MARKET_SUFFIX_NAME.GetDefaultDecimal = function(symbol) {
      return that.coinDigitalNum
    } // 默认小数位数
    // 商用去掉提醒文字'仅学习使用'
    if (HQChart.Chart.JSChart.GetResource().FrameLogo) {
      HQChart.Chart.JSChart.GetResource().FrameLogo.Text = null
    }
  },
  beforeDestroy() {
    if (this.KLineChart) this.KLineChart.ChartDestory()
    if (this.initTimer) {
      clearTimeout(this.initTimer)
      this.initTimer = null
    }
  },
  methods:
    {
      OnSize() {
        var width = this.$refs.right.clientWidth
        // var rightTab = this.$refs.rightTab
        // var periodWrap = this.$refs.minute_periodWrap;
        // var indexWrap = this.$refs.minute_indexWrap;
        // var statementWrap = this.$refs.minute_statementWrap;
        // var chartHeight = window.innerHeight - rightTab.offsetHeight - periodWrap.offsetHeight - indexWrap.offsetHeight - statementWrap.offsetHeight;

        // var kline = this.$refs.kline;
        // kline.style.width = width + 'px';
        // kline.style.height = chartHeight + 'px';

        // var width = this.$refs.kline_right.clientWidth;
        var periodWrap = this.$refs.kline_boxwp
        // var indexWrap = this.$refs.kline_indexWrap;
        // var statementWrap = this.$refs.kline_statementWrap;
        var chartHeight = this.$refs.right.clientHeight - periodWrap.offsetHeight
        var kline2 = this.$refs.kline2
        kline2.style.width = width + 'px'
        kline2.style.height = chartHeight + 'px'

        if (this.Chart) this.Chart.OnSize()
        if (this.KLineChart) this.KLineChart.OnSize()
      },

      changeRightContent(type) {
        this.chartType = type

        this.$nextTick(() => {
          this.OnSize()
        })
      },

      SetChartStyle() {
        HDF.HQData.SetMinuteChartCoordinate()
        var blackStyle = HQChart.Chart.HQChartStyle.GetStyleConfig(HQChart.Chart.STYLE_TYPE_ID.BLACK_ID) // 读取黑色风格配置
        // 自定义修改颜色
        blackStyle.BGColor = '#ff0000' // 背景色
        // blackStyle.TooltipBGColor = 'rgb(255, 0, 0)' // 背景色
        // blackStyle.TooltipAlpha = 0.92 // 透明度
        // 边框
        blackStyle.FrameBorderPen = '#FF0000'
        // K线颜色
        blackStyle.UpBarColor = '#FF6060' // 上涨
        blackStyle.DownBarColor = '#00FFFF' // 下跌
        blackStyle.UnchagneBarColor = 'rgb(228,228,228)' // 平盘
        // K线信息文字
        blackStyle.UpTextColor = '#FF6060'	// 上涨
        blackStyle.DownTextColor = '#00FFFF'	// 下跌
        blackStyle.UnchagneTextColor = 'rgb(101,104,112)' // 平盘
        //
        // 修改配色
        // blackStyle.FrameBorderPen = '#FF0000'// 边框
        blackStyle.FrameSplitPen = '#FF0000'// 分割线
        // blackStyle.FrameSplitTextColor = '#FF0000'// 刻度文字颜色

        HQChart.Chart.JSChart.SetStyle(blackStyle)
      },

      CreateMinuteChart() {
        if (this.Chart) return
        if (!this.selfItem?.symbolId) return

        var option = DefaultData.GetMinuteOption(`${this.selfItem?.symbolId}_32.sh`)
        option.Symbol = this.Symbol
        option.NetworkFilter = (data, callback) => { this.NetworkFilter(data, callback) } // 网络请求回调函数

        var chart = HQChart.Chart.JSChart.Init(this.$refs.kline)
        chart.SetOption(option)
        this.Chart = chart
      },

      CreateKLineChart() {
        if (this.KLineChart) return
        if (!this.selfItem?.symbolId) {
          const _this = this
          this.initTimer = setTimeout(() => {
            _this.CreateKLineChart()
            clearTimeout(_this.initTimer)
            _this.initTimer = null
          }, 300)
          return
        }

        var option = DefaultData.GetKLineOption(this.isLong, `${this.selfItem.symbolId}_32.sh`, this.time)
        option.Symbol = this.Symbol
        option.NetworkFilter = (data, callback) => { this.NetworkFilter(data, callback) } // 网络请求回调函数

        var chart = HQChart.Chart.JSChart.Init(this.$refs.kline2)

        chart.SetOption(option)
        this.KLineChart = chart
        // 自定义tooltip
        HQChart.Chart.JSChart.GetDivTooltipDataFormat().DataMap.set('HistoryDataStringFormat', { Create: () => { return new CustomHistoryDataStringFormat(this.coinDigitalNum, this.quantityNum) } })
        // 自定义分割线
        // 注册监听事件 y轴
        this.KLineChart.AddEventCallback(
          {
            event: HQChart.Chart.JSCHART_EVENT_ID.ON_SPLIT_YCOORDINATE,
            callback: (event, data, obj) => { this.OnSplitYCoordinate(event, data, obj) }
          })
        // 注册监听事件 x轴
        this.KLineChart.AddEventCallback(
          {
            event: HQChart.Chart.JSCHART_EVENT_ID.ON_SPLIT_XCOORDINATE,
            callback: (event, data, obj) => { this.OnSplitXCoordinate(event, data, obj) }
          })
        // 注册监听事件 title
        this.KLineChart.AddEventCallback(
          {
            event: HQChart.Chart.JSCHART_EVENT_ID.ON_TITLE_DRAW,
            callback: (event, data, obj) => { this.DrawTooltip(event, data, obj) }
          })
        // 外部处理键盘消息
        // this.KLineChart.JSChartContainer.SuperOnKeyDown = this.KLineChart.JSChartContainer.OnKeyDown // 备份下原来的键盘处理函数
        // this.KLineChart.JSChartContainer.OnKeyDown = (e) => { this.HQChartOnKeyDown(e) }
        // 注册监听鼠标点击事件,显示/隐藏tooltip
        this.KLineChart.AddEventCallback(
          {
            event: HQChart.Chart.JSCHART_EVENT_ID.ON_CLICK,
            callback: (event, data, chart) => { this.OnClickHQChart(event, data, chart) }
          }
        )
      },
      // 鼠标点击事件
      OnClickHQChart(event, data, chart)
      {
        this.isShowTooltipSelf = !this.isShowTooltipSelf
      },
      // 自定义tooltip
      DrawTooltip(event, data, obj)
      {
        if (data.Draw)
        {
          var item = data.Draw
          // var tpName = this.$refs.tooltipname
          // tpName.innerText = obj.Name
          // 日期
          // var tpDateLabel = this.$refs.tooltipdatelable
          // var tpDate = this.$refs.tooltipdate
          // var tpTime = this.$refs.tooltiptime
          // if (HQChart.Chart.ChartData.IsMinutePeriod(this.Chart.JSChartContainer.Period, true)) // 是否是分钟周期
          // {
          //   tpTime.innerText = `${HQChart.Chart.IFrameSplitOperator.FormatDateString(item.Date)} ${HQChart.Chart.IFrameSplitOperator.FormatTimeString(item.Time)}` // 格式化时间
          // }
          // else
          // {
          //   tpTime.innerText = HQChart.Chart.IFrameSplitOperator.FormatDateString(item.Date) // 格式化时间
          // }
          const TitleColor = '#ffffff'
          const WEEK_NAME = ['日', '一', '二', '三', '四', '五', '六']
          var date = new Date(parseInt(item.Date / 10000), (item.Date / 100 % 100 - 1), item.Date % 100)
          var strDate = `${String(item.Date).slice(0, 4)}-${String(item.Date).slice(4, 6)}-${String(item.Date).slice(6, 8)}`// 日期 可以根据需求自己格式化日期
          var title2 = `星期${WEEK_NAME[date.getDay()]}` // 星期
          if (item.Time >= 0) title2 = `${String(item.Time).length === 3 ? String(item.Time).slice(0, 1) : String(item.Time).slice(0, 2)}:${String(item.Time).slice(-2)}` // 时间 可以根据需求自己格式化日
          var increase = null
          if (item.YClose > 0) increase = (item.Close - item.YClose) / item.YClose * 100
          var hl = item.YClose > 0 ? item.Close - item.YClose : null
          for (var val of this.tooltipData) {
            switch (val.en) {
              case 'date':
              {
                // val.vol = strDate + ' ' + title2
                val.vol = item.Date
                val.titleColor = TitleColor
                val.color = TitleColor
                val.svol = title2
                break
              }
              case 'Open':
              {
                val.vol = item.Open.toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = this.GetColor(item.Open, item.YClose)
                break
              }
              case 'High':
              {
                val.vol = item.High.toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = this.GetColor(item.High, item.YClose)
                break
              }
              case 'Low':
              {
                val.vol = item.Low.toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = this.GetColor(item.Low, item.YClose)
                break
              }
              case 'Close':
              {
                val.vol = item.Close.toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = this.GetColor(item.Close, item.YClose)
                break
              }
              case 'Ave':
              {
                val.vol = (item.Vol > 0 ? item.Amount / item.Vol * 100 : item.Open).toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = TitleColor
                break
              }
              case 'hl':
              {
                val.vol = hl == null ? '--' : hl.toFixed(this.coinDigitalNum)
                val.titleColor = TitleColor
                val.color = this.GetColor(increase, 0)
                break
              }
              case 'increase':
              {
                val.vol = increase == null ? '--' : increase.toFixed(2) + '%'
                val.titleColor = TitleColor
                val.color = this.GetColor(increase, 0)
                break
              }
              case 'Vol': // 数量
              {
                val.vol = this.amountFixFormat(item.Vol / 100)
                val.titleColor = TitleColor
                val.color = TitleColor
                break
              }
              case 'Amount':
              {
                val.vol = this.amountFixFormat(item.Amount)
                val.titleColor = TitleColor
                val.color = TitleColor
                break
              }
              case 'Position':
              {
                val.vol = item.Position == 0 ? '--' : this.amountFixFormat(item.Position * (window.g.APP_WINNY_NAME === '尚志汇农' ? 2 : 1))
                val.titleColor = TitleColor
                val.color = TitleColor
                break
              }
              default:
                break
            }
          }

          // 如果隐藏 数据还是要更新的
          // if (this.IsShowTooltip == false) tooltip.style.display = 'none'
          // else tooltip.style.display = 'inline'
        }
        else
        {
          // tooltip.style.display = 'none'
        }
      },
      // 以下为格式化工具
      amountFixFormat(intN) { // 四舍五入
        if (typeof intN === 'number') {
          if (intN > 100000000) {
            return (intN / 100000000).toFixed(2) + '亿'
          } else if (intN > 10000) {
            return (intN / 10000).toFixed(2) + '万'
          } else {
            return intN.toFixed(this.quantityNum) + ''
          }
        } else {
          return intN
        }
      },
      amountWFormat(intN) { // 向上取整
        if (typeof intN === 'number') {
          if (intN > 100000000) {
            return this.upFixed(intN / 100000000, 2) + '亿'
          } else if (intN > 10000) {
            return this.upFixed(intN / 10000, 2) + '万'
          } else {
            // 2021.12.16修改不要小数点
            return Math.ceil(intN)
          }
        } else {
          return intN
        }
      },
      /**
      * 向上取整
      * @param {原数字} num
      * @param {保留的小数位数} fix
      * @returns
      */
      upFixed(num, fix) {
        let result = '0'
        if (Number(num) && fix > 0) {
          // 简单的做个判断
          fix = +fix || 2
          num = num + ''
          if (/e/.test(num)) {
            // 如果是包含e字符的数字直接返回
            result = num
          } else if (!/\./.test(num)) {
            // 如果没有小数点
            result = num + `.${Array(fix + 1).join('0')}`
          } else {
            // 如果有小数点
            num = num + `${Array(fix + 1).join('0')}`
            const reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
            const floorStr = reg.exec(num)[0]
            if (+floorStr >= +num) {
              result = floorStr
            } else {
              const floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
              const point = /\./.test(floorNumber + '') ? '' : '.'
              const floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
              result = reg.exec(floorStr2)[0]
            }
          }
        }
        return result
      },
      GetColor(price, yclse)
      {
        this.UpColor = 'rgb(238,21,21)' // 上涨颜色
        this.DownColor = 'rgb(25,158,0)' // 下跌颜色
        this.UnchagneColor = 'rgb(255,255,255)' // 平盘
        if (price > yclse) return this.UpColor
        else if (price < yclse) return this.DownColor
        else return this.UnchagneColor
      },
      HQChartOnKeyDown(e)
      {
        var keyID = e.keyCode ? e.keyCode : e.which
        switch (keyID)
        {
          case 27: // ESC  隐藏十字线和tooltip
            // this.KLineChart.JSChartContainer.EnableShowCorssCursorLine(false)
            // this.KLineChart.JSChartContainer.DrawDynamicInfo()
            // this.EnableShowTooltip(false)
            break
          case 37: // left
          case 39: // right
            // 键盘左右移动的时候重新显示十字线和tooltip
            // this.KLineChart.JSChartContainer.EnableShowCorssCursorLine(true)
            // this.EnableShowTooltip(true)
            break
        }
        // this.KLineChart.JSChartContainer.SuperOnKeyDown(e)
      },
      EnableShowTooltip(b) {
        this.isShowTooltipSelf = b
      },
      ChangeSymbol(symbol) // 切换股票
      {
        // var symbolUpper=symbol.toUpperCase();
        // var isShowVolChart=HDF.HQData.IsShowVolChart(symbolUpper);
        // var frame=this.Chart.JSChartContainer.Frame.SubFrame[1];
        // if (isShowVolChart)
        // {
        //     if (frame.Height<=0) frame.Height=this.VolChartHeight;
        // }
        // else
        // {
        //     if (frame.Height>0) this.VolChartHeight=frame.Height;
        //     frame.Height=0;
        // }

        // var period=this.KLineChart.JSChartContainer.Period;
        // var isShowRightMenu=HDF.HQData.IsEnableRight(period, symbol); //是否显示复权菜单
        // this.IsShowRightMenu=isShowRightMenu;

        this.Symbol = symbol
        // this.Chart.ChangeSymbol(this.Symbol);
        // this.KLineChart.ChangeSymbol(this.Symbol)
        // 判断图表是否加载,若未加载调用创建图表的方法
        if (this.KLineChart) {
          this.KLineChart.ChangeSymbol(symbol)
        } else {
          this.CreateKLineChart()
        }
      },
      OnSplitYCoordinate(event, data, obj) // 自定义分割线 监听Y轴刻度文字创建事件
      {
        // data.ID 第几个指标窗口
        var frame = data.Frame

        for (var i in frame.HorizontalInfo)
        {
          var item = frame.HorizontalInfo[i]
          //  item数据类型及含义
          // this.Value // 坐标数据
          // this.Message = new Array() // 坐标输出文字信息
          // this.TextColor = g_JSChartResource.FrameSplitTextColor // 文字颜色
          // this.Font = g_JSChartResource.FrameSplitTextFont // 字体
          // this.LineColor = g_JSChartResource.FrameSplitPen // 线段颜色
          // this.LineType = 1 //线段类型 -1 不画线段 2 虚线 1实线
          item.LineColor = '#FF0000'
          item.LineType = 2
          item.LineDash = [3, 3]
        }
      },
      OnSplitXCoordinate(event, data, obj) // 自定义分割线 监听X轴刻度文字创建事件
      {
        // data.ID 第几个指标窗口
        var frame = data.Frame
        for (var i in frame.VerticalInfo)
        {
          var item = frame.VerticalInfo[i]
          //  item数据类型及含义
          // this.Value // 坐标数据
          // this.Message = new Array() // 坐标输出文字信息
          // this.TextColor = g_JSChartResource.FrameSplitTextColor // 文字颜色
          // this.Font = g_JSChartResource.FrameSplitTextFont // 字体
          // this.LineColor = g_JSChartResource.FrameSplitPen // 线段颜色
          // this.LineType = 1 //线段类型 -1 不画线段 2 虚线 1实线
          item.LineType = -1
        }
      },
      OnClickMinuteDayMenu(index, item) // 分时图天数
      {
        this.MinuteDayIndex = index
        this.Chart.ChangeDayCount(item.ID)
      },

      OnClickKLinePeriodMenu(index, item) // K线周期
      {
        this.KLinePeriodIndex = index
        if (index) {
          this.KLineChart.ChangePeriod(item.ID)
          this.$emit('changefs', false, item, index)
        } else {
          this.$emit('changefs', true, item, index)
        }
      },

      OnClickKLineRightMenu(index, item) // K线复权
      {
        this.KLineRightIndex = index
        this.KLineChart.ChangeRight(item.ID)
      },

      ChangeMinuteIndex(item) // 切换分时图指标
      {
        if (this.Chart) this.Chart.ChangeIndex(item.WindowIndex, item.ID)
      },

      ChangeKLineIndex(item) // 切换K线图指标
      {
        if (this.KLineChart) this.KLineChart.ChangeIndex(item.WindowIndex, item.ID)
      },

      NetworkFilter(data, callback) // 第3方数据替换接口
      {
        switch (data.Name) {
          // 分时图数据对接
          case 'MinuteChartContainer::RequestMinuteData':
            HDF.HQData.NetworkFilter(data, callback)
            break
          case 'MinuteChartContainer::RequestHistoryMinuteData':
            HDF.HQData.NetworkFilter(data, callback)
            break

          case 'KLineChartContainer::RequestHistoryData': // 日线全量数据下载
            HDF.HQData.NetworkFilter(data, callback)
            break
          case 'KLineChartContainer::RequestRealtimeData': // 日线实时数据更新
            HDF.HQData.NetworkFilter(data, callback)
            break

          case 'KLineChartContainer::RequestFlowCapitalData': // 流通股本
            HDF.HQData.NetworkFilter(data, callback)
            break

          case 'KLineChartContainer::ReqeustHistoryMinuteData': // 分钟全量数据下载
            HDF.HQData.NetworkFilter(data, callback)
            break
          case 'KLineChartContainer::RequestMinuteRealtimeData': // 分钟增量数据更新
            HDF.HQData.NetworkFilter(data, callback)
            break

          case 'KLineChartContainer::RequestDragMinuteData': // 分钟历史拖拽下载
            HDF.HQData.NetworkFilter(data, callback)
            break
        }
      },

      handleSelect(key, keyPath) {
        this.ChangeSymbol(keyPath[1])
      },

      handleOpen(key, keyPath) {

      },

      handleClose(key, keyPath) {

      }
    }
}
</script>

<style lang="less" scoped>
@animation-duration: 0.3s;
.chartbox{
  background: #141517;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .left{
    width: 240px;
    height: 100%;
    box-sizing: border-box;
    left: 0;
    // padding-top: 17px;
    overflow-x: auto;

    .el-menu{
      min-height: 100%;
      border-right: solid 1px #000;

      .el-submenu__title:hover{
        background-color: #363636!important;
      }

      .el-menu-item:hover {
        background-color: #363636!important;
      }
    }

  }

  .right{
    left: 0px;
    width: 100%;
    height: 100%;
    @rightTabHeight: 40px;
    display: flex;
    flex-direction: column;

    .rightTab{
        height: @rightTabHeight;
        width: 100%;
        background: #191919;
        border-bottom: 1px solid #000;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        // flex-direction: column;

        >.btn{
            cursor: pointer;
            width: 100%;
            text-align: center;
            color: #bcbfc4;

            &:first-child{
                padding-right: 60px;
                text-align: right;
            }

            &:last-child{
                padding-left: 60px;
                text-align: left;
            }

            &:hover,
            &.active
            {
            color: #ff6900;
            }

        }
    }

    .rightContent{
        height: calc(100% - @rightTabHeight);
        width: 100%;

        .kline_boxwp{
            padding-left: 37px;
            display: flex;
            justify-content: flex-start;
             background: #161719;
            border-bottom: 1px solid #1b1d24;
            // border-top: 1px solid #1b1d24;
            border-radius: 4px 4px 0 0;
        }
    }

    .btnGroup{
      display: flex;
      height: 37px;
      display: flex;
      align-items: center;
      .chartbtn{
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 12px;
        color: #989898;
        height: 17px;
        width: fit-content;
        margin-right: 20px;
        border: 1px solid #131625;
       
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:last-child{
          border-right: none;
        }

        &:hover{
          color: #f2f2f2;
        }
        &.active
        {
          padding: 3px 7px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #989898;
          background-color: rgba(80, 80, 80, 0.3);
        }
      }
    }

    // .el-button-group{
    //   width: 100%;
    //   display: flex;

    //   .el-button{
    //     flex: 1;
    //   }
    // }

    #hqchart_minute
    {
      background-color: rgb(0,0,0);
      height: 300px;
      position: relative;
    }

    #hqchart_kline
    {
      background-color: rgb(0,0,0);
      height: 300px;
      position: relative;
    }
    // 自定义tooltip
    #customtooltip
    {
      position: absolute;
      right: 0;
      top: 40px;
      width: 55px;
      background: #000000aa;
      border: 1px solid #ffffffaa;
      display: flex;
      flex-direction: column;
      font-size: 10px;
      .customtooltiprow{
        flex: 1;
        // display: flex;
        // flex-direction: row;
        // align-items: center;
        // justify-content: space-between;
        .customtooltipleft{
          display: block;
          text-align: left;
        }
        .customtooltipright{
          display: block;
          text-align: right;
        }
      }
      // button{
      //   background: #357ce1;
      //   color: #fff;
      //   border: none;
      //   padding: none;
      //   margin: none;
      // }
    }
    .statementWrap{
        background: #191919;
        padding: 10px;
        font-size: 12px;
        color: #de432d;
        line-height: 20px;
        text-align: center;
    }
  }
}

</style>
<style lang="scss">
#hqchart_kline{
  .target-header strong,.parameter-header strong{
    top: 0;
  }
  .parameter-footer{
    display: flex;
    justify-content: space-around;
    button{
      margin: 0;
      padding: 0 15px;
    }
  }
}
</style>
